module.exports = {
      id: "user-icon-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "svg-sprite-84e6ba0859b67d2a822c8ad28bb7a5bc.svg#user-icon",
      toString: function () {
        return this.url;
      }
    }